const user = {
  id: null,
  fullName: null,
  firstName: null,
  lastName: null,
  emailAddress: null,
  password: null,
  active: null,
  createdBy: null,
  securityRoles: []
}

export default () => Object.assign({}, user)
